import Head from "next/head";

const FaqSchema = ({ faqData }) => {
  const faqHTML = faqData || "";

 function extractFaqServer(html) {
  const faqList = [];

  const sections = html.split('class="accordion-section"').slice(1);

  sections.forEach(block => {
    const questionMatch = block.match(/class="accordion-section-title"[^>]*>(.*?)<\/[^>]+>/);
    const answerMatch   = block.match(/class="allCatLink"[^>]*>(.*?)<\/[^>]+>/);

    const question = questionMatch?.[1]?.trim();
    const answer = answerMatch?.[1]?.trim();

    if (question && answer) {
      faqList.push({ question, answer });
    }
  });

  return faqList;
}
const faqList = extractFaqServer(faqHTML);
//   console.log("faqList", faqList);

  return (
    <Head>
      <script
        id="FAQPageSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqList.map((item) => ({
              "@type": "Question",
              name: item.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: item.answer,
              },
            })),
          }),
        }}
      />
    </Head>
  );
};

export default FaqSchema;
